import requestFinish from '@/helpers/check-all-request-fInish';
// import app from '@/main';
import eventBus from '@/setup/eventBus';
import store from '@/store';
import i18n from '@/i18n';
// import { useRouter } from 'vue-router';
import router from '@/router';

import {
  AUTH_LOGOUT,
  AUTH_2FA_RESET,
  CHANGE_ENOUGH_PERMISSIONS,
}
from '@/store/action_types/auth';


/**
 * метод игнорирует ошибки,
 * и не выводит notification error
 */
const ignoreErrorNotifyCountRequest = (error: any) => {
  const splitUrl = error.config.url.split('/');

  if (splitUrl[splitUrl.length - 1] === 'count') {
    return true;
  }

  return false;
};

/**
 * получает message от первой ошибки в списке ошибок
 */
const getFirstErrorFromList = (errors: any) => errors?.[
  Object.keys(errors)[0] || ''
]?.[0]?.message;

export default {
  requestSuccessInterceptor(config: any) {
    if (config.url === '/dashboards/stats') {
      requestFinish(config.url, 'set');
    }

    eventBus.$emit('request-start');
    return config;
  },
  requestErrorInterceptor(error: any) {
    eventBus.$emit('request-fail');
    return Promise.reject(error);
  },
  responseSuccessInterceptor(response: any) {
    if (response.config.url === '/dashboards/stats') {
      requestFinish(response.config.url, 'delete');
    }

    eventBus.$emit('connection-enabled');
    eventBus.$emit('response-success');
    return response;
  },
  responseErrorInterceptor(error: any) {
    // const { $route, $router } = app.config.globalProperties;
    const route = router.currentRoute;
    const queryUrl = error.config.url;
    if (queryUrl === '/dashboards/stats') {
      requestFinish(queryUrl, 'delete');
    }

    eventBus.$emit('response-error', error);
    eventBus.$emit('connection-lost');

    const errorMessage = error.response.data.message;
    const { t } = i18n.global;

    try {
      if (error.response) {
        switch (error.response.status) {
        case 401:
          if (error.response.data.code === 'AUTH_INVALID_CREDENTIALS_ERROR') {
            eventBus.$emit('notify-event', {
              type: 'error',
              text: errorMessage,
            });
            store.commit(`auth/${AUTH_LOGOUT}`);
            store.dispatch('session/clearTimers');
            if (route.value.path !== '/login/auth') {
              router.push('/login/auth');
            }
            break;
          }

          if (error.response.data.code === 'AUTH_ACCOUNT_INACTIVE_ERROR') {
            eventBus.$emit('notify-event', {
              type: 'error',
              text: errorMessage,
            });
            break;
          }

          if (error.response.data.code === 'AUTH_CREDENTIALS_NOT_PROVIDED_ERROR') {
            eventBus.$emit('notify-event', {
              type: 'error',
              text: errorMessage,
            });
            store.commit(`auth/${AUTH_LOGOUT}`);
            store.dispatch('session/clearTimers');
            router.replace('/login/auth');
            break;
          }

          if (error.response.data.errors === null) {
            eventBus.$emit('notify-event', {
              type: 'error',
              text: errorMessage,
            });
          }
          break;

        case 423:
          eventBus.$emit('notify-event', {
            type: 'error',
            text: errorMessage,
          });
          if (error.response.data.code === 'TOTP_LOCKED_ERROR') {
            eventBus.$emit('checkSensitiveAction', '');
            break;
          }

          store.dispatch(`auth/${AUTH_2FA_RESET}`)
            .then(() => {
              router.push('/login/2fa');
            });
          break;

        case 403:
          eventBus.$emit('notify-event', {
            type: 'error',
            text: errorMessage,
          });
          break;
        case 404:
          eventBus.$emit('notify-event', {
            type: 'error',
            text: errorMessage,
          });
          //@ts-expect-error matched typings
          router.push(route.value.matched[0]);
          break;
        case 405:
          if (ignoreErrorNotifyCountRequest(error)) break;
          if (error.response.data.code === 'NOT_ENOUGH_PERMISSIONS_ERROR' && route.value.path !== '/profile') {
            store.dispatch(`auth/${CHANGE_ENOUGH_PERMISSIONS}`);
            router.push('/profile');
          }
          eventBus.$emit('notify-event', {
            type: 'error',
            text: errorMessage,
          });
          break;
        case 422:
          // Override error message for kyc rules
          const kycRulesMessage = error.response?.data?.errors?.kyc_rules?.[0]?.message;

          if (kycRulesMessage) {
            eventBus.$emit('notify-event', {
              type: 'error',
              text: kycRulesMessage,
            });
            break;
          }

          if (error.response?.data?.errors?.hasOwnProperty('recaptcha_token')) {
            break;
          }

          if (queryUrl === '/domains-management/platform-betting-domains') {
            const errorMessageFirstFromList = getFirstErrorFromList(error.response?.data?.errors);
            eventBus.$emit('notify-event', {
              type: 'error',
              text: errorMessageFirstFromList,
            });
            break;
          }
          eventBus.$emit('notify-event', {
            type: 'error',
            text: errorMessage,
          });
          break;
        case 429:
          eventBus.$emit('flood-warning', error.response.data);
          break;
        default:
          if (error.response.status.toString()[0] === '5') {
            eventBus.$emit('notify-event', {
              type: 'error',
              text: t('validation.errors[2]'),
            });
          }
          break;
        }
      }
    } catch (e) {
      window.console.error('Unknown response error: ', e);
      eventBus.$emit('notify-event', {
        type: 'error',
        text: 'UNKNOWN ERROR, PLEASE RETRY',
      });
    }
    eventBus.$emit('connection-enabled');
    return Promise.reject(error.response);
  },
};
